import { atom } from 'recoil';

export const selectedStandardItem = atom({
  key: 'Solicitation/selectedStandardItem',
  default: null,
});

export const showSolicitationModal = atom({
  key: 'Solicitation/showSolicitationModal',
  default: false,
});

export const getOptionsByUniqueKey = (allOptions, uniqueKey) => {
  return allOptions
    .filter((item) => item.uniqueKey === uniqueKey)
    .map((option) => ({ label: option.label, value: option.value }))
    .sort((a, b) => (a.label < b.label ? -1 : 1));
};

export const getCurrentAAC = (allOptions) => {
  const aacOptions = allOptions.filter((item) => item.uniqueKey === 'aac');
  const currentOption = aacOptions.find(
    (option) => option.additionalProps?.isCurrent,
  );
  return currentOption?.value || aacOptions[0]?.value || '';
};

export const parseJSONErrorMessage = (errorMessage) => {
  try {
    return JSON.parse(errorMessage).message;
  } catch {
    return errorMessage;
  }
};

export const getUpiidDetailsNextPath = (
  bidType,
  solicitationId,
  goToEdit = false, // for create and renew pages when user clicks "Save" and stays in step 1
) => {
  if (goToEdit) return `/catalog/solicitations/edit/${solicitationId}`;
  return `/catalog/solicitations/edit/${solicitationId}/${
    bidType === 'OUTSIDE_FLEET' ? 'select-sin' : 'open-period'
  }`;
};

export const breadcrumbsPath = [
  {
    location: `${globalThis.AFP_CONFIG.appURLs.home}/home`,
    label: 'Home',
  },
  {
    location: '/catalog/solicitations',
    label: 'Solicitations',
  },
];
